import React, { useState } from "react"
import { Form, message } from "antd"
import "../../styles/Components/inputfields.css"
import "../../styles/Components/adduser.css"
import { useSelector } from "react-redux"
import { Invites } from "../../Apis/invitesApis"
import UserModalStructure from "../Common/UserModalStructure"
import { translations } from "../../utils/Translation/staticTranslation"
import { jwtDecode } from "jwt-decode"
import { getUserCookies } from "../../utils/Cookies"

const ERROR_MESSAGE_DURATION = 3

const AddUserModal = ({ isModalOpen, handleCancel }) => {
  const [form] = Form.useForm()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const user = useSelector((state) => state.user.user)
  const highest_role =
    getUserCookies()?.token && jwtDecode(getUserCookies()?.token).highest_role

  const lang = localStorage.getItem("language") || "ar"
  const AddUserModal = translations[lang]?.userPage?.ad_user_modal

  const handleCancelModal = () => {
    form.resetFields()
    setIsSubmitting(false)
    handleCancel()
  }

  const onFinish = async (values) => {
    setIsSubmitting(true)
    const payload = {
      business: user.business_id,
      role_type: values.role,
      invited_by: user.email,
      invited_to: values.email,
    }
    try {
      const response = await Invites.sendInvite(payload)
      if (response.status === 201) {
        message.success(AddUserModal?.invite_send_successfully)
        handleCancelModal()
      }
    } catch (error) {
      message.error(
        lang === "en"
          ? error.response.data.error
          : error.response.data.errorArabic,
        ERROR_MESSAGE_DURATION
      )
      setTimeout(() => {
        setIsSubmitting(false)
      }, ERROR_MESSAGE_DURATION * 1000)
    }
  }
  const roleOptions =
    highest_role === "OWNER"
      ? [
          { value: "admin", label: AddUserModal?.admin },
          { value: "viewer", label: AddUserModal?.viewer },
        ]
      : [{ value: "viewer", label: AddUserModal?.viewer }]

  return (
    <UserModalStructure
      isModalOpen={isModalOpen}
      handleCancel={handleCancelModal}
      title={AddUserModal?.add_user}
      subtitle={AddUserModal?.text}
      buttonText={AddUserModal?.send_invites_btn}
      onFinish={onFinish}
      isEmailDisabled={false}
      form={form}
      roleOptions={roleOptions}
      isSubmitting={isSubmitting}
    />
  )
}

export default AddUserModal
